import { RouteCardItemDto } from "../../route/RouteCardItemDto";

export class ContadorsDto {
	public packetCount: number = 0;
	public palletCount: number = 0;
	public kilosCount: number = 0;
	public litresCount: number = 0;
	public productCount: number = 0;
	public quantityProduct: number = 0;
	public shipmentCount: number = 0;

	public showCounts: boolean;
	public showPalletCountOnRouteCard: boolean;
	public showKilosCountOnRouteCard: boolean;
	public showLitresCountOnRouteCard: boolean;
	public showQuantityProductOnRouteCard: boolean;
	public showPacketCountOnRouteCard: boolean;
	public showProductCountOnRouteCard: boolean;
	public showShipmentCountOnRouteCard: boolean;

	public static buildByListRoutes(routes: RouteCardItemDto[]): ContadorsDto{
		let r: ContadorsDto = new ContadorsDto();
		if(routes == null)
			return r;

		routes.forEach(value => {
			r.kilosCount += value.kilosCount > 0 ? value.kilosCount : 0;
			r.litresCount += value.litresCount > 0 ? value.litresCount : 0;
			r.palletCount += value.palletCount > 0 ? value.palletCount : 0;
			r.packetCount += value.packetCount > 0 ? value.packetCount : 0;
			r.productCount += value.productCount > 0 ? value.productCount : 0;
			r.quantityProduct += value.quantityProduct > 0 ? value.quantityProduct : 0;
			r.shipmentCount += value.shipmentCount;

			r.showPalletCountOnRouteCard = r.showPalletCountOnRouteCard || value.showPalletCountOnRouteCard;
			r.showKilosCountOnRouteCard = r.showKilosCountOnRouteCard || value.showKilosCountOnRouteCard;
			r.showLitresCountOnRouteCard = r.showLitresCountOnRouteCard || value.showLitresCountOnRouteCard;
			r.showQuantityProductOnRouteCard = r.showQuantityProductOnRouteCard || value.showQuantityProductOnRouteCard;
			r.showPacketCountOnRouteCard = r.showPacketCountOnRouteCard || value.showPacketCountOnRouteCard;
			r.showProductCountOnRouteCard = r.showProductCountOnRouteCard || value.showProductCountOnRouteCard;
			r.showShipmentCountOnRouteCard = r.showShipmentCountOnRouteCard || value.showShipmentCountOnRouteCard;

		});
        
        return r;
	}
}